import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Card, Grid } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import Icon from "@mui/material/Icon";

function RateTable({ selectedDevice, rateTableData, onDataUpdate }) {
  const [editableData, setEditableData] = useState([]);

  useEffect(() => {
    if (rateTableData) {
      setEditableData(rateTableData.map((record) => ({ ...record })));
    }
  }, [rateTableData]);

  const handleFieldChange = (recordIndex, field, value) => {
    const updatedData = [...editableData];
    updatedData[recordIndex] = {
      ...updatedData[recordIndex],
      [field]: value,
    };
    setEditableData(updatedData);
  };

  const handleNameChange = (recordIndex, value) => {
    const updatedData = [...editableData];
    updatedData[recordIndex] = {
      ...updatedData[recordIndex],
      Name: value,
    };
    setEditableData(updatedData);
  };

  const handleSave = (recordIndex) => {
    const { id, ...data } = editableData[recordIndex];
    if (onDataUpdate) {
      onDataUpdate(data, id);
    }
  };

  const renderEditableTable = (record, index) => {
    const tableName = `Rate: ${record.id}`;
    const tableTitle = `${record.Name} Milk Vendor Rank 0 Morning Shift`;

    const fields = [
      { label: "FAT Min", key: "FatMin" },
      { label: "FAT Max", key: "FatMax" },
      { label: "SNF Min", key: "SnfMin" },
      { label: "SNF Max", key: "SnfMax" },
      { label: "Kg FAT", key: "kgFat" },
      { label: "FAT cutoff", key: "FatCutoff" },
      { label: "FAT deduct", key: "FatDeduct" },
      { label: "Kg SNF", key: "kgSnf" },
      { label: "SNF cutoff", key: "SnfCutoff" },
      { label: "SNF deduct", key: "SnfDeduct" },
    ];

    return (
      <Card key={index} sx={{ mb: 3 }}>
        <MDBox
          mx={2}
          mt={-3}
          py={3}
          px={2}
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
        >
          <Grid container alignItems="center" spacing={2}>
            <Grid item xs={10}>
              <MDTypography variant="h5" color="white">
                {tableName}
              </MDTypography>
            </Grid>
            <Grid item xs={2}>
              <MDButton
                variant="outlined"
                color="white"
                size="small"
                onClick={() => handleSave(index)}
                startIcon={<Icon>save</Icon>}
              >
                Save
              </MDButton>
            </Grid>
          </Grid>
        </MDBox>
        <MDBox pt={3} pb={3} px={2}>
          <Grid container alignItems="center" spacing={1}>
            <Grid item>
              <MDInput
                value={record.Name || ""}
                onChange={(e) => handleNameChange(index, e.target.value)}
                placeholder="Vendor Name"
                style={{
                  fontSize: "1.25rem",
                  fontWeight: 600,
                  minWidth: "150px",
                }}
              />
            </Grid>
            <Grid item>
              <MDTypography variant="h6" color="dark">
                Milk Vendor Rank 0 Morning Shift
              </MDTypography>
            </Grid>
          </Grid>
          <Grid container spacing={2} sx={{ px: 3 }}>
            {fields.map((field, fieldIndex) => (
              <Grid item xs={12} sm={6} md={4} lg={2.4} key={fieldIndex}>
                <MDBox mb={2}>
                  <MDTypography variant="caption" fontWeight="bold" color="text">
                    {field.label}
                  </MDTypography>
                  <MDInput
                    type="number"
                    value={record[field.key] || ""}
                    onChange={(e) => handleFieldChange(index, field.key, e.target.value)}
                    placeholder={field.label}
                    fullWidth
                    inputProps={{ step: "0.1" }}
                  />
                </MDBox>
              </Grid>
            ))}
          </Grid>
        </MDBox>
      </Card>
    );
  };

  return (
    <MDBox>
      {editableData && editableData.length > 0 ? (
        editableData.map((record, index) => renderEditableTable(record, index))
      ) : (
        <Card>
          <MDBox
            mx={2}
            mt={-3}
            py={3}
            px={2}
            variant="gradient"
            bgColor="info"
            borderRadius="lg"
            coloredShadow="info"
          >
            <MDTypography variant="h6" color="white">
              Rate Table for Device {selectedDevice}
            </MDTypography>
          </MDBox>
          <MDBox pt={3} pb={3}>
            <MDTypography variant="body2" color="text" textAlign="center">
              No rate table data available for this device.
            </MDTypography>
          </MDBox>
        </Card>
      )}
    </MDBox>
  );
}

RateTable.propTypes = {
  selectedDevice: PropTypes.string.isRequired,
  rateTableData: PropTypes.arrayOf(PropTypes.object),
  onDataUpdate: PropTypes.func,
};

export default RateTable;
